import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiairportcabservices() {



    const cardData = {

keyword: "Navi Mumbai Airport Cab Service",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai Airport Cab Service for airport transfers, local travel, corporate commuting, family trips, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, flight tracking support, transparent pricing, and doorstep pickup across Navi Mumbai and nearby regions, we ensure a smooth, comfortable, and hassle-free travel experience to and from Navi Mumbai Airport.",

topPlaces: [
    {
        title: "Panvel Junction",
        description:
            "Panvel Junction is a major railway and highway hub connecting Mumbai, Pune, and Konkan routes, making it one of the busiest travel points near Navi Mumbai Airport."
    },
    {
        title: "Kharghar Valley",
        description:
            "Kharghar Valley is known for scenic hills, waterfalls during monsoon, and the iconic Central Park, making it a popular leisure destination near Navi Mumbai."
    },
    {
        title: "Belapur CBD",
        description:
            "CBD Belapur is a key commercial and government hub in Navi Mumbai with corporate offices, making it a high-demand zone for airport cab services."
    },
    {
        title: "Ulwe Growth Corridor",
        description:
            "Ulwe is a rapidly developing residential and business area near Navi Mumbai Airport, becoming a major hotspot for daily cab travel and airport transfers."
    },
    {
        title: "Seawoods Coastal Hub",
        description:
            "Seawoods is a modern residential and shopping hub with Seawoods Grand Central Mall, restaurants, and strong transport connectivity."
    },
    {
        title: "Nerul Residential Zone",
        description:
            "Nerul is a well-planned residential area with schools, markets, and railway connectivity, making it a key pickup and drop location for airport cabs."
    },
    {
        title: "Palm Beach Road Corridor",
        description:
            "Palm Beach Road is one of the smoothest driving routes in Navi Mumbai offering scenic views and fast connectivity to airport zones."
    },
    {
        title: "Taloja MIDC Industrial Area",
        description:
            "Taloja MIDC is a major industrial zone near Navi Mumbai Airport, frequently used for corporate and business cab services."
    },
    {
        title: "Uran Coastal Belt",
        description:
            "Uran is a coastal region near Navi Mumbai Airport known for ports, beaches, and growing development, making it an important travel zone."
    },
    {
        title: "Dronagiri Node",
        description:
            "Dronagiri is an emerging residential and logistics hub near the airport, expected to grow rapidly with airport development and infrastructure projects."
    }
],



services: [
{
name: "Navi Mumbai Airport Cab Service",
description: "Mumbai Airport Cab offers Navi Mumbai Airport Cab Service for safe, reliable, and comfortable airport transfers across Navi Mumbai and nearby areas. Whether you need airport pickup, airport drop, business travel, family transfer, or emergency ride, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller. Our professional chauffeurs ensure punctual service, smooth highway driving, luggage assistance, and stress-free airport travel. With 24x7 availability, doorstep pickup, real-time support, and transparent pricing, we make your airport journey simple and comfortable."
},
{
name: "Navi Mumbai Airport Taxi Service",
description: "Navi Mumbai Airport Taxi Service by Mumbai Airport Cab provides dependable and comfortable taxi solutions for all airport travel needs. Our clean, air-conditioned vehicles and experienced chauffeurs ensure timely pickup and drop, safe driving, and smooth travel experience for passengers."
},
{
name: "Airport Cab Service Navi Mumbai",
description: "Airport Cab Service Navi Mumbai ensures fast and reliable transportation for passengers travelling to and from the airport. Mumbai Airport Cab offers professional chauffeurs, well-maintained vehicles, and 24x7 availability for hassle-free airport travel."
},
{
name: "Navi Mumbai Airport Taxi",
description: "Navi Mumbai Airport Taxi service provides comfortable and affordable rides for airport transfers. Mumbai Airport Cab ensures punctual pickup, smooth rides, and safe transportation for solo, family, and corporate travellers."
},
{
name: "Navi Mumbai Airport Cab",
description: "Navi Mumbai Airport Cab service offers reliable airport pickup and drop with clean vehicles and experienced drivers. Mumbai Airport Cab ensures safe and timely transportation for all passengers."
},
{
name: "Book Cab Service for Navi Mumbai Airport",
description: "Book Cab Service for Navi Mumbai Airport allows quick and easy online booking for airport transfers. Mumbai Airport Cab provides instant confirmation, transparent pricing, and multiple vehicle options for convenience."
},
{
name: "Online Navi Mumbai Airport Cab Service",
description: "Online Navi Mumbai Airport Cab Service enables digital booking for fast and hassle-free airport travel. Mumbai Airport Cab ensures 24x7 availability, real-time support, and easy reservations."
},
{
name: "Best Cab Service Navi Mumbai Airport",
description: "Best Cab Service Navi Mumbai Airport provides premium and reliable airport transportation with professional chauffeurs and comfortable vehicles ensuring a smooth travel experience."
},
{
name: "Reliable Airport Cab Service Navi Mumbai",
description: "Reliable Airport Cab Service Navi Mumbai ensures safe, punctual, and consistent airport transfers. Mumbai Airport Cab guarantees high-quality service for all types of passengers."
},
{
name: "Cheapest Cab Service Navi Mumbai Airport",
description: "Cheapest Cab Service Navi Mumbai Airport offers budget-friendly airport travel without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing and reliable service."
},
{
name: "24x7 Navi Mumbai Airport Cab Service",
description: "24x7 Navi Mumbai Airport Cab Service provides round-the-clock airport transportation for all flight schedules. Mumbai Airport Cab ensures availability anytime, day or night."
},
{
name: "Late Night Airport Cab Service Navi Mumbai",
description: "Late Night Airport Cab Service Navi Mumbai ensures safe and secure transportation during late-night or midnight flight timings. Mumbai Airport Cab provides experienced drivers and comfortable vehicles."
},
{
name: "Early Morning Airport Taxi Navi Mumbai",
description: "Early Morning Airport Taxi Navi Mumbai service provides timely pickups for early flights. Mumbai Airport Cab ensures punctual drivers and smooth travel experience."
},
{
name: "Corporate Cab Service Navi Mumbai Airport",
description: "Corporate Cab Service Navi Mumbai Airport is designed for business professionals requiring punctual and executive airport transfers. Mumbai Airport Cab ensures premium comfort and reliable service."
},
{
name: "Luxury Airport Cab Service Navi Mumbai",
description: "Luxury Airport Cab Service Navi Mumbai offers high-end vehicles for premium airport travel experience. Mumbai Airport Cab ensures comfort, style, and professional chauffeurs."
},
{
name: "Airport Transfer Service Navi Mumbai",
description: "Airport Transfer Service Navi Mumbai provides complete pickup and drop solutions for all airport travel needs. Mumbai Airport Cab ensures safe, punctual, and comfortable journeys."
},
{
name: "Innova Airport Cab Service Navi Mumbai",
description: "Innova Airport Cab Service Navi Mumbai offers spacious and comfortable travel for families and groups. Mumbai Airport Cab ensures luggage space and smooth rides."
},
{
name: "Sedan Airport Cab Service Navi Mumbai",
description: "Sedan Airport Cab Service Navi Mumbai provides economical and comfortable airport travel for solo and small groups. Mumbai Airport Cab ensures timely pickup and safe travel."
},
{
name: "SUV Airport Cab Service Navi Mumbai",
description: "SUV Airport Cab Service Navi Mumbai offers spacious and powerful vehicles for comfortable airport transfers. Mumbai Airport Cab ensures safe and reliable service."
},
{
name: "Tempo Traveller Airport Service Navi Mumbai",
description: "Tempo Traveller Airport Service Navi Mumbai is ideal for large groups and corporate travel. Mumbai Airport Cab ensures ample seating and professional chauffeur service."
},
{
name: "Safe Airport Cab Service in Navi Mumbai",
description: "Safe Airport Cab Service in Navi Mumbai ensures secure and reliable airport transfers with experienced drivers and well-maintained vehicles."
},
{
name: "AC Taxi Service Navi Mumbai Airport",
description: "AC Taxi Service Navi Mumbai Airport provides air-conditioned comfortable rides for airport pickup and drop. Mumbai Airport Cab ensures smooth and relaxing travel."
},
{
name: "One Way Airport Cab Service Navi Mumbai",
description: "One Way Airport Cab Service Navi Mumbai offers affordable single-journey airport transfers without return charges. Mumbai Airport Cab ensures transparent pricing and reliable service."
}
],

tableData: [
["Navi Mumbai Airport Cab Service","Navi Mumbai Airport Taxi Service"],
["Airport Cab Service Navi Mumbai","Navi Mumbai Airport Taxi"],
["Navi Mumbai Airport Cab","Book Cab Service for Navi Mumbai Airport"],
["Online Navi Mumbai Airport Cab Service","Best Cab Service Navi Mumbai Airport"],
["Reliable Airport Cab Service Navi Mumbai","Cheapest Cab Service Navi Mumbai Airport"],
["24x7 Navi Mumbai Airport Cab Service","Late Night Airport Cab Service Navi Mumbai"],
["Early Morning Airport Taxi Navi Mumbai","Corporate Cab Service Navi Mumbai Airport"],
["Luxury Airport Cab Service Navi Mumbai","Airport Transfer Service Navi Mumbai"],
["Innova Airport Cab Service Navi Mumbai","Sedan Airport Cab Service Navi Mumbai"],
["SUV Airport Cab Service Navi Mumbai","Tempo Traveller Airport Service Navi Mumbai"]
],









whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai Airport Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai Airport Cab Services for airport pickups, drops, corporate travel, family transportation, hotel transfers, and outstation journeys."
    },
    {
        WhyChooseheading: "Timely Airport Pickup and Drop Solutions",
        WhyChoosedescription: "Our airport transfer services are designed to provide punctual pickups and smooth drop-offs, ensuring passengers reach their destination comfortably and on time."
    },
    {
        WhyChooseheading: "Perfect for Business and Corporate Travelers",
        WhyChoosedescription: "Executives, corporate teams, and business professionals rely on our airport cab services for meetings, conferences, office transfers, and VIP transportation."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "Local and Outstation Airport Transfers",
        WhyChoosedescription: "Our cab services are available for travel within Mumbai as well as direct transfers to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Surat, Ahmedabad, and other destinations."
    },
    {
        WhyChooseheading: "Flight Tracking and Professional Coordination",
        WhyChoosedescription: "We monitor flight schedules and coordinate pickups accordingly, ensuring a seamless travel experience even during flight delays or schedule changes."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel Experience",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, route expertise, punctual service, and a comfortable journey for every passenger."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Groups",
        WhyChoosedescription: "From individual travelers and families to corporate groups and tourists, we provide suitable airport transportation solutions for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "What is Navi Mumbai Airport Cab Service?",
        answer: "Navi Mumbai Airport Cab Service provides airport pickup and drop transportation for passengers traveling to and from Navi Mumbai International Airport."
    },
    {
        question: "Can I pre-book a cab for Navi Mumbai Airport transfers?",
        answer: "Yes, customers can book airport cabs in advance to ensure timely pickups and hassle-free transportation."
    },
    {
        question: "Which vehicles are available for airport transfers?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles are available."
    },
    {
        question: "Do you provide airport pickup and drop services 24/7?",
        answer: "Yes, airport transfer services are available throughout the day and night according to customer travel schedules."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many companies and business professionals use our airport cab services for executive transportation and corporate travel."
    },
    {
        question: "Are Tempo Travellers available for group airport transfers?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate teams, tourists, and event transportation."
    },
    {
        question: "Do drivers monitor flight arrival schedules?",
        answer: "Yes, flight timings are monitored to ensure timely pickups even if flights are delayed or rescheduled."
    },
    {
        question: "Can I book a cab from Navi Mumbai Airport to outstation destinations?",
        answer: "Yes, customers can directly travel from Navi Mumbai Airport to Pune, Nashik, Shirdi, Mahabaleshwar, Lonavala, Surat, Ahmedabad, and many other locations."
    },
    {
        question: "Is advance booking recommended for airport transportation?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth airport travel arrangements."
    },
    {
        question: "How can I book a Navi Mumbai Airport Cab Service?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Chirag Mehta",
        feedback:
            "My airport transfer was handled perfectly from booking to drop-off. The cab arrived on time, the vehicle was spotless, and the driver was extremely professional.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Neeta Sharma",
        feedback:
            "We arranged a family airport pickup through Mumbai Airport Cabs and the experience was excellent. The vehicle was spacious, comfortable, and the entire journey was stress-free.",
        rating: 5
    }
];




























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Navi Mumbai Airport Cab Service",
"image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-airport-cab-service.jpg",
"description": "Book Navi Mumbai Airport cab service for reliable airport pickup and drop. Mumbai Airport Cabs offers safe, comfortable, and timely taxi service with professional drivers and 24x7 availability for all airport transfers.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/navi-mumbai-airport-cab-service"
}
};











    return (
        <div>


<Helmet>
  <title>Navi Mumbai Airport Cab Service | 24x7 Airport Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Navi Mumbai Airport cab service for fast and reliable airport transfers. Safe, comfortable taxis with professional drivers and 24x7 availability."
/>

<meta
 name="keywords"
 content="navi mumbai airport cab service, navi mumbai airport taxi service, airport cab service navi mumbai, navi mumbai airport taxi, navi mumbai airport cab, book cab service for navi mumbai airport, online navi mumbai airport cab service, best cab service navi mumbai airport"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaiairportcabservices;